import { IServiceResult } from "../../infrastructure/Interfaces/IServiceResult";
import { SVCCombos } from "../../infrastructure/services/api/SVCCombos";
import IViewComunas from "../../presentation/view-interfaces/IViewComunas";
import IViewComunasAuto from "../../presentation/view-interfaces/IViewComunasAuto";
import IViewGenero from "../../presentation/view-interfaces/IViewGenero";
import IViewGeneroCmb from "../../presentation/view-interfaces/IViewGeneroCmb";
import IViewPaisNacionalidad from "../../presentation/view-interfaces/IViewPaisNacionalidad";
import IViewPaisNacionalidadCmb from "../../presentation/view-interfaces/IViewPaisNacionalidadCmb";

export const ObtieneComuna = (selListaComunas: any, codigoNegocio: number) => {
    let list: Array<IViewComunas> = [];
    let _list: Array<IViewComunasAuto> = [];
    SVCCombos.ObtieneComuna(codigoNegocio).then((res: IServiceResult<any>) => {
        if (res.result !== undefined) {
            let data: any = res.result;
            for (let I = 0; I < data.length; I++) {
                list.push({
                    codComuna: data[I].codComuna,
                    nombre: data[I].nombre,
                    codProvincia: data[I].codProvincia
                });

                _list.push({
                    ID: data[I].codComuna,
                    descripcion: data[I].nombre
                });
            }

            selListaComunas(false, '', list, _list);
            // selListaComunas(false, 
            //                 '', 
            //                 list.sort(function(a, b){
            //                     var nameA = a.nombre.toLowerCase(),
            //                         nameB = b.nombre.toLowerCase();
            //                     if( nameA < nameB ) return -1;
            //                     if( nameA > nameB ) return 1;
            //                     return 0;
            //                 }), 
            //                 _list.sort(function(a, b){
            //                     var nameA = a.descripcion.toLowerCase(),
            //                         nameB = b.descripcion.toLowerCase();
            //                     if( nameA < nameB ) return -1;
            //                     if( nameA > nameB ) return 1;
            //                     return 0;
            //                 })
            //                 );
        } else {
            selListaComunas(true, res.errorDetails, list, _list);
        }
    });
};

export const ObtieneGenero = (selListaGenero: any) => {
    let list: Array<IViewGenero> = [];
    let _list: Array<IViewGeneroCmb> = [];
    SVCCombos.ObtieneGenero().then((res: IServiceResult<any>) => {
        if (res.result !== undefined) {
            let data: any = res.result;
            for (let I = 0; I < data.length; I++) {
                list.push({
                    codsexo: data[I].codsexo,
                    nombre: data[I].nombre,
                    estado: data[I].estado,
                });

                _list.push({
                    ID: data[I].codsexo,
                    descripcion: data[I].nombre
                });

            }

            selListaGenero(false, '', list, _list);
        } else {
            selListaGenero(true, res.errorDetails, list, _list);
        }
    })

};

export const ObtienePaisNacionalidad = (selListaPaisNacionalidad: any, codigoNegocio: number) => {
    let list: Array<IViewPaisNacionalidad> = [];
    let _list: Array<IViewPaisNacionalidadCmb> = [];
    SVCCombos.ObtienePaisNacionalidad(codigoNegocio).then((res: IServiceResult<any>) => {
        if (res.result !== undefined) {
            let data: any = res.result;
            for (let I = 0; I < data.length; I++) {
                list.push({
                    codPais: data[I].codPais,
                    nombre: data[I].nombre,
                    nacionalidad: data[I].nacionalidad,
                    estado: data[I].estado
                });

                _list.push({
                    ID: data[I].codPais,
                    descripcion: data[I].nacionalidad
                });
            }

            selListaPaisNacionalidad(false, '', list, _list);
        }
        else {
            selListaPaisNacionalidad(true, res.errorDetails, list, _list);
        }
    })
};
export const ObtieneComunaHomologa = (    
    SelObtieneComunaHomologa:any,
    CodComuna: number,
    Comuna_Db_Finanzas:string,
    Cod_Comuna_Db_Docencia:number  
) => {
    SVCCombos.ObtieneComunaHomologa(
        CodComuna,
        Comuna_Db_Finanzas,
        Cod_Comuna_Db_Docencia
    ).then((res: any) => {
        if (res.result !== undefined) {
            SelObtieneComunaHomologa(false, '', res.result);
        } else {
            SelObtieneComunaHomologa(true, res.errorDetails, res.result);
        }
    });
};

